import { render } from "./BsfpScheduleView.vue?vue&type=template&id=4a16e963&scoped=true"
import script from "./BsfpScheduleView.vue?vue&type=script&lang=js"
export * from "./BsfpScheduleView.vue?vue&type=script&lang=js"

import "./BsfpScheduleView.vue?vue&type=style&index=0&id=4a16e963&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a16e963"]])

export default __exports__